webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
var Store = {
    data: {
        user: {},
        documentSets: {},
        currentDocumentSet: {}
    },
    destroy: function destroy() {
        this.data.user = {};
        this.data.documentSets = {};
        this.data.currentDocumentSet = {};
    }
};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_q__);






var UserService = function () {
    function UserService() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserService);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserService, [{
        key: 'authenticate',
        value: function authenticate(username, password) {
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/login',
                'method': 'POST',
                'headers': {
                    'authorization': 'Basic ' + btoa(username + ':' + password)
                }
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings))).then(this.storeUserLocally);
        }
    }, {
        key: 'forgotPassword',
        value: function forgotPassword(username) {
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/forgot-password',
                method: 'POST',
                data: {
                    email: username,
                    resetUrl: window.location.origin + '/#/password-reset/?token={token}&username=' + encodeURIComponent(username)
                }
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword(username, password, token, isNewAccount) {
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/reset-password',
                method: 'POST',
                data: {
                    email: username,
                    newPassword: password
                }
            });

            var tokenName = isNewAccount ? 'invitationToken' : 'passwordResetToken';
            settings.data[tokenName] = token;
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
        }
    }, {
        key: 'requestVerificationEmail',
        value: function requestVerificationEmail() {
            return this.get().then(sendVerificationFor);

            function sendVerificationFor(user) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/users/' + user.id + '/request-verification',
                    method: 'POST',
                    data: {
                        email: user.email,
                        resetUrl: window.location.origin + '/#/verify/?token={token}&username=' + encodeURIComponent(user.email) + '&id=' + user.id
                    }
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
            }
        }
    }, {
        key: 'verifyToken',
        value: function verifyToken(token) {
            return this.get().then(sendTokenFor);

            function sendTokenFor(user) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/users/' + user.id + '/verify-account',
                    method: 'POST',
                    data: {
                        email: user.email,
                        verificationToken: token
                    }
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
            }
        }
    }, {
        key: 'get',
        value: function get() {
            if (__WEBPACK_IMPORTED_MODULE_3__store_js__["a" /* Store */].data.user && __WEBPACK_IMPORTED_MODULE_3__store_js__["a" /* Store */].data.user.id) return __WEBPACK_IMPORTED_MODULE_4_q___default.a.when(__WEBPACK_IMPORTED_MODULE_3__store_js__["a" /* Store */].data.user);
            return this.hydrate();
        }
    }, {
        key: 'hydrate',
        value: function hydrate() {
            var id = localStorage.getItem('UserId');
            var apiKey = localStorage.getItem('UserApiKey');
            if (!(id && apiKey)) return __WEBPACK_IMPORTED_MODULE_4_q___default.a.reject({ message: 'No saved API key.' });

            __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].apiKey = apiKey;
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/users/' + id
            });

            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)), true).then(this.storeUserLocally);
        }
    }, {
        key: 'storeUserLocally',
        value: function storeUserLocally(data) {
            var user = data.entity;
            __WEBPACK_IMPORTED_MODULE_3__store_js__["a" /* Store */].data.user = user;
            if (user.apiKey) {
                __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].apiKey = data.entity.apiKey;
                localStorage.setItem('UserApiKey', data.entity.apiKey);
                localStorage.setItem('UserId', data.entity.id);
            }
            return user;
        }
    }, {
        key: 'logout',
        value: function logout() {
            return this.get().then(this.requestLogout).catch(this.clearUser);
        }
    }, {
        key: 'requestLogout',
        value: function requestLogout(user) {
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/logout',
                'method': 'POST'
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings))).then(this.clearUser);
        }
    }, {
        key: 'clearUser',
        value: function clearUser(data) {
            __WEBPACK_IMPORTED_MODULE_3__store_js__["a" /* Store */].destroy();
            __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].apiKey = undefined;
            localStorage.removeItem('UserApiKey');
            localStorage.removeItem('UserId');
            return data;
        }
    }, {
        key: 'updateUser',
        value: function updateUser(user) {
            var userData = {
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName
            };
            if (user.password) userData.password = user.password;
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/users/' + user.id,
                method: 'PUT',
                data: {
                    user: userData
                }
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings))).then(updateStoredUser);

            function updateStoredUser() {
                $.extend(__WEBPACK_IMPORTED_MODULE_3__store_js__["a" /* Store */].data.user, user);
            }
        }
    }, {
        key: 'isAuthenticated',
        get: function get() {
            return this.get().then(function () {
                return true;
            }).catch(function () {
                return false;
            });
        }
    }]);

    return UserService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new UserService());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_q__);






var APIService = function () {
    function APIService() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, APIService);

        this.requestCount = 0;
        this.errors = [];
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(APIService, [{
        key: 'resetErrors',
        value: function resetErrors() {
            this.errors = [];
        }
    }, {
        key: 'waitFor',
        value: function waitFor(promise, silentError) {
            var service = this;
            if (service.requestCount === 0) service.resetErrors();
            service.requestCount++;
            return promise.catch(failure).finally(function () {
                service.requestCount--;
            });

            function failure(xhr) {
                if (!silentError) {
                    var messages = ['An unexpected error occurred.'];
                    if (xhr.statusText) {
                        messages = [xhr.statusText];
                    }
                    if (xhr.responseText) {
                        xhr.responseJSON = JSON.parse(xhr.responseText);
                    }
                    if (xhr.responseJSON) {
                        if (xhr.responseJSON.message) {
                            messages = [xhr.responseJSON.message];
                        }
                        if (xhr.responseJSON.error) {
                            if (xhr.responseJSON.error.message) {
                                messages = [xhr.responseJSON.error.message];
                            }
                        }
                        if (xhr.responseJSON.data) {
                            if (xhr.responseJSON.data.message) {
                                messages = [xhr.responseJSON.data.message];
                            }
                            if (xhr.responseJSON.data.form && xhr.responseJSON.data.form.children) {
                                var children = xhr.responseJSON.data.form.children;
                                var errors = [];
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(children)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var child = _step.value;

                                        if (children[child].errors) errors = errors.concat(children[child].errors);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (errors.length > 0) messages = errors;
                            }
                        }
                    }
                    service.errors = service.errors.concat(messages);
                }
                throw xhr;
            }
        }
    }, {
        key: 'defaultSettingsPlus',
        value: function defaultSettingsPlus(settings) {
            var defaults = {
                'async': true,
                'crossDomain': true,
                'method': 'GET'
            };
            if (this.apiKey) defaults.headers = {
                'X-Lewis-Rice-Api-Key': this.apiKey
            };
            return $.extend(defaults, settings);
        }
    }, {
        key: 'baseURL',
        get: function get() {
            return 'https://api.lrepdocs.com';
        }
    }, {
        key: 'apiKey',
        set: function set(key) {
            this.key = key;
        },
        get: function get() {
            return this.key;
        }
    }, {
        key: 'isWaiting',
        get: function get() {
            return this.requestCount > 0;
        }
    }, {
        key: 'errorsOccurred',
        get: function get() {
            return this.errors.length > 0;
        }
    }, {
        key: 'errorList',
        get: function get() {
            return this.errors;
        }
    }]);

    return APIService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new APIService());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Logout__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PasswordReset__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PasswordReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PasswordReset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Verify__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Verify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Verify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DocumentSets__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DocumentSets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_DocumentSets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DocumentsView__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DocumentsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_DocumentsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DocumentsShare__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DocumentsShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_DocumentsShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DocumentsInvitations__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DocumentsInvitations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_DocumentsInvitations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PrimaryAttorneyDisplay__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PrimaryAttorneyDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_PrimaryAttorneyDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Terms__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Terms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Privacy__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Privacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_UserSettings__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_UserSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_UserSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AcceptInvitation__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AcceptInvitation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_AcceptInvitation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_user_service__ = __webpack_require__(3);


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Login___default.a,
        meta: { public: true }
    }, {
        path: '/password-reset',
        name: 'PasswordReset',
        component: __WEBPACK_IMPORTED_MODULE_4__components_PasswordReset___default.a,
        meta: { public: true }
    }, {
        path: '/terms',
        name: 'Terms',
        component: __WEBPACK_IMPORTED_MODULE_11__components_Terms___default.a,
        meta: { public: true }
    }, {
        path: '/privacy',
        name: 'Privacy',
        component: __WEBPACK_IMPORTED_MODULE_12__components_Privacy___default.a,
        meta: { public: true }
    }, {
        path: '/accept-invitation',
        name: 'AcceptInvitation',
        component: __WEBPACK_IMPORTED_MODULE_14__components_AcceptInvitation___default.a,
        meta: { public: true }
    }, {
        path: '/verify',
        name: 'Verify',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Verify___default.a,
        meta: { public: false }
    }, {
        path: '/',
        name: 'DocumentSets',
        component: __WEBPACK_IMPORTED_MODULE_6__components_DocumentSets___default.a
    }, {
        path: '/documents-view/:setType/:setId',
        name: 'DocumentsView',
        component: __WEBPACK_IMPORTED_MODULE_7__components_DocumentsView___default.a
    }, {
        path: '/documents-view/:setType/:setId/share',
        name: 'DocumentsShare',
        component: __WEBPACK_IMPORTED_MODULE_8__components_DocumentsShare___default.a
    }, {
        path: '/documents-view/:setType/:setId/invite',
        name: 'DocumentsInvitations',
        component: __WEBPACK_IMPORTED_MODULE_9__components_DocumentsInvitations___default.a
    }, {
        path: '/user-settings',
        name: 'UserSettings',
        component: __WEBPACK_IMPORTED_MODULE_13__components_UserSettings___default.a
    }, {
        path: '/logout',
        name: 'Logout',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Logout___default.a
    }]

});

router.beforeEach(function (to, from, next) {
    if (to.name == 'Logout') {
        __WEBPACK_IMPORTED_MODULE_15__services_user_service__["a" /* default */].logout().then(logoutComplete).catch(function (error) {
            console.log(error);
            next(false);
        });
    }
    if (to.meta.public) {
        next();
    } else {
        __WEBPACK_IMPORTED_MODULE_15__services_user_service__["a" /* default */].get().then(checkVerification).catch(noUser);
    }

    function checkVerification(user) {
        if (to.name == 'Verify') {
            if (user.isVerified) {
                next('/');
            } else {
                next();
            }
        } else {
            if (user.isVerified) {
                next();
            } else {
                console.log('Route guard found unverified user, redirecting for verification.');
                next('/verify');
            }
        }
    }

    function logoutComplete() {
        next('/login');
    }

    function noUser(reason) {
        console.log('Route guard found no user, redirecting to login.');
        next('/login?redirect=' + encodeURIComponent(to.fullPath));
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_q__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_q__);







var DocumentSetsService = function () {
    function DocumentSetsService() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DocumentSetsService);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DocumentSetsService, [{
        key: 'getOwned',
        value: function getOwned() {
            var service = this;
            return __WEBPACK_IMPORTED_MODULE_3__services_user_service__["a" /* default */].get().then(getSetsFor).then(transform);

            function getSetsFor(user) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/users/' + user.id + '/owneddocumentsets'
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_5_q___default()($.ajax(settings)));
            }

            function transform(response) {
                var sets = response.entities;
                for (var i in sets) {
                    var set = sets[i];
                    set.setType = 'owneddocumentsets';
                    service.sortUserLinks(set);
                }
                return sets;
            }
        }
    }, {
        key: 'getShared',
        value: function getShared() {
            var service = this;
            return __WEBPACK_IMPORTED_MODULE_3__services_user_service__["a" /* default */].get().then(getSetsFor).then(transform);

            function getSetsFor(user) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/users/' + user.id + '/shareddocumentsets'
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_5_q___default()($.ajax(settings)));
            }

            function transform(response) {
                var sets = response.entities;
                for (var i in sets) {
                    var set = sets[i];
                    set.setType = 'shareddocumentsets';
                    service.sortUserLinks(set);
                }
                return sets;
            }
        }
    }, {
        key: 'getAll',
        value: function getAll() {
            var service = this;
            return __WEBPACK_IMPORTED_MODULE_3__services_user_service__["a" /* default */].get().then(getSetsFor).spread(combine);

            function getSetsFor(user) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({});
                return __WEBPACK_IMPORTED_MODULE_5_q___default.a.all([service.getOwned(), service.getShared()]);
            }
            function combine(ownedSets, sharedSets) {
                return { ownedSets: ownedSets, sharedSets: sharedSets };
            }
        }
    }, {
        key: 'getSet',
        value: function getSet(setId, setType) {
            var service = this;
            return __WEBPACK_IMPORTED_MODULE_3__services_user_service__["a" /* default */].get().then(getSetFor).then(transform);

            function getSetFor(user) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/users/' + user.id + '/' + setType + '/' + setId
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_5_q___default()($.ajax(settings)));
            }

            function transform(response) {
                var set = response.entity;
                set.setType = setType;
                service.sortUserLinks(set);
                for (var i in set.documents) {
                    set.documents[i].selected = false;
                }
                return set;
            }
        }
    }, {
        key: 'categorizeSet',
        value: function categorizeSet(set) {
            var service = this;
            return categorize(set);

            function categorize(set) {
                var sortedDocuments = {};
                var categories = set.documents.map(function (a) {
                    return a.documentCategory;
                }).sort(function (a, b) {
                    return a.rank - b.rank;
                }).filter(function (val, i, self) {
                    return self.indexOf(val) === i;
                });
                for (var key in categories) {
                    var category = categories[key];
                    sortedDocuments[category.name] = set.documents.filter(function (val, i, self) {
                        return val.documentCategory.id === category.id;
                    }).sort(function (a, b) {
                        return a.rank - b.rank;
                    });
                }
                return sortedDocuments;
            }
        }
    }, {
        key: 'sortUserLinks',
        value: function sortUserLinks(set) {
            var service = this;
            set.owners = set.userLinks.filter(function (userLink, i, self) {
                return userLink.relationType == 'primary';
            });
            if (set.setType == 'owneddocumentsets') {
                set.attorneys = set.userLinks.filter(function (userLink, i, self) {
                    return userLink.relationType == 'primary_attorney';
                });
                set.sharedUsers = set.userLinks.filter(function (userLink, i, self) {
                    return userLink.relationType == 'shared';
                });
                set.staff = set.userLinks.filter(function (userLink, i, self) {
                    return userLink.relationType == 'support_staff';
                });
            }
            return set;
        }
    }]);

    return DocumentSetsService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new DocumentSetsService());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_q__);






var UserInvitationsService = function () {
    function UserInvitationsService() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserInvitationsService);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserInvitationsService, [{
        key: 'getInvitationsForDocumentSet',
        value: function getInvitationsForDocumentSet(setId) {
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/documentsets/' + setId + '/userinvitations'
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings))).then(function (result) {
                return result.entities;
            });
        }
    }, {
        key: 'postInvitationForDocumentSet',
        value: function postInvitationForDocumentSet(setId, payload) {
            if (payload.userFirstName === '' || payload.userLastName === '' || payload.userEmail === '') {
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default.a.reject({ statusText: 'Must complete all fields.' }));
            }
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/documentsets/' + setId + '/userinvitations',
                method: 'POST',
                data: {
                    user_invitation: payload
                },

                dataType: 'text'
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
        }
    }, {
        key: 'postInvitationsForDocumentSet',
        value: function postInvitationsForDocumentSet(setId, payloads) {
            var _this = this;

            var promises = payloads.map(function (payload) {
                return _this.postInvitationForDocumentSet(setId, payload);
            });
            return __WEBPACK_IMPORTED_MODULE_4_q___default.a.all(promises);
        }
    }, {
        key: 'revokeAccessForDocumentSet',
        value: function revokeAccessForDocumentSet(setId, invitation) {
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/documentsets/' + setId + '/userlinks/' + invitation.id,
                method: 'DELETE',
                dataType: 'text'
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
        }
    }, {
        key: 'getInvitationWithToken',
        value: function getInvitationWithToken(invitationId, token) {
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/userinvitations/' + invitationId + '?token=' + token
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)), true).then(function (result) {
                return result.entity;
            });
        }
    }, {
        key: 'getInvitationsForUser',
        value: function getInvitationsForUser() {
            return __WEBPACK_IMPORTED_MODULE_3__services_user_service__["a" /* default */].get().then(requestInvitationsFor);

            function requestInvitationsFor(user) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/users/' + user.id + '/userinvitations'
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings))).then(function (result) {
                    return result.entities;
                }).then(function (invitations) {
                    return invitations.filter(function (invitation) {
                        return invitation.shareStatus == 'invited';
                    });
                });
            }
        }
    }, {
        key: 'handleInvitation',
        value: function handleInvitation(invitation, status) {
            var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                url: __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/userinvitations/' + invitation.id,
                method: 'PUT',

                dataType: 'text',
                data: {
                    user_invitation: {
                        shareStatus: status,
                        tokenConfirmation: invitation.invitationToken,
                        version: invitation.version
                    }
                }
            });
            return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
        }
    }, {
        key: 'acceptInvitation',
        value: function acceptInvitation(invitation) {
            return this.handleInvitation(invitation, 'accepted');
        }
    }, {
        key: 'declineInvitation',
        value: function declineInvitation(invitation) {
            return this.handleInvitation(invitation, 'declined');
        }
    }]);

    return UserInvitationsService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new UserInvitationsService());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(245)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  "data-v-52025e8b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(238)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  "data-v-13fc035b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(243)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavbarAlt__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavbarAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_NavbarAlt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_user_service__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* Store */],
            apiService: __WEBPACK_IMPORTED_MODULE_0__services_api_service__["a" /* default */],
            year: new Date().getFullYear()
        };
    },
    components: {
        'navbar': __WEBPACK_IMPORTED_MODULE_2__components_NavbarAlt___default.a
    },
    computed: {
        isAuthenticated: function isAuthenticated() {
            return this.store.data.user.id;
        }
    }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user_invitations_service__ = __webpack_require__(21);






/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'accept-invitation',

    data: function data() {
        return {
            checkComplete: false,
            invitation: {}
        };
    },


    computed: {
        token: function token() {
            return this.$route.query.token;
        },
        invitationId: function invitationId() {
            return this.$route.query.id;
        }
    },

    created: function created() {
        __WEBPACK_IMPORTED_MODULE_1__services_user_service__["a" /* default */].logout().then(this.getInvitation);
    },

    methods: {

        getInvitation: function getInvitation() {
            __WEBPACK_IMPORTED_MODULE_2__services_user_invitations_service__["a" /* default */].getInvitationWithToken(this.invitationId, this.token).then(use.bind(this)).catch(failure.bind(this)).finally(cleanup.bind(this));

            function use(invitation) {
                this.invitation = invitation;
                if (invitation.user.isVerified) __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
                return invitation;
            }

            function failure(xhr) {
                if (xhr.status >= 400) __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
            }

            function cleanup() {
                this.checkComplete = true;
            }
        },

        goSetPassword: function goSetPassword() {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/password-reset?token=' + this.token + '&username=' + encodeURIComponent(this.invitation.user.email) + '&newaccount');
        }
    }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_js__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'documentItem',

    props: ['document', 'sharingEnabled'],

    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* Store */]
        };
    },


    computed: {
        apiDomain: function apiDomain() {
            return __WEBPACK_IMPORTED_MODULE_0__services_api_service__["a" /* default */].baseURL + this.document.documentFileUrl;
        }
    },

    methods: {

        updateSelected: function updateSelected(evt) {
            $(evt.currentTarget).toggleClass('selected');
            $(evt.currentTarget).children('i').toggleClass('fa-square-o fa-check-square-o');
            this.document.selected = $(evt.currentTarget).hasClass('selected');
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'documentSetHeader',
  props: ['documentSet']
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_document_sets_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user_invitations_service__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_js__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'documentSets',

    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_5__store_js__["a" /* Store */],
            invitations: []
        };
    },


    computed: {
        documentSetsExist: function documentSetsExist() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.store.data.documentSets).length > 0;
        }
    },

    created: function created() {
        this.requestAll();
    },

    methods: {

        requestAll: function requestAll() {
            var promises = [this.requestDocumentSetsList(), this.requestInvitationsForUser()];
            return __WEBPACK_IMPORTED_MODULE_4_q___default.a.all(promises).then(use.bind(this)).then(redirectIfNeeded.bind(this));

            function use(result) {
                this.store.data.documentSets = result[0];
                this.invitations = result[1];
                return result;
            }

            function redirectIfNeeded(result) {
                var combinedDocSets = this.store.data.documentSets.ownedSets.concat(this.store.data.documentSets.sharedSets);
                if (combinedDocSets.length == 1 && this.invitations.length == 0) {
                    this.$router.push('/documents-view/' + combinedDocSets[0].setType + '/' + combinedDocSets[0].id);
                }
                return result;
            }
        },

        requestDocumentSetsList: function requestDocumentSetsList() {
            return __WEBPACK_IMPORTED_MODULE_1__services_document_sets_service__["a" /* default */].getAll();
        },

        requestInvitationsForUser: function requestInvitationsForUser() {
            return __WEBPACK_IMPORTED_MODULE_2__services_user_invitations_service__["a" /* default */].getInvitationsForUser();
        },

        handleInvitation: function handleInvitation(invitation, status) {
            __WEBPACK_IMPORTED_MODULE_2__services_user_invitations_service__["a" /* default */].handleInvitation(invitation, status).then(this.requestAll);
        }
    }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DocumentSetHeader__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DocumentSetHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DocumentSetHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_document_sets_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user_invitations_service__ = __webpack_require__(21);







/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'documentsShare',

    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* Store */],
            invitations: [],
            invitationToAdd: {},
            recipients: []
        };
    },


    created: function created() {
        this.requestDocumentSet(this.setId, this.setType);
        this.requestDocumentSetInvitations(this.setId);
        this.resetForm();
        this.addRecipient();
    },

    computed: {
        setId: function setId() {
            return this.$route.params.setId;
        },
        setType: function setType() {
            return this.$route.params.setType;
        }
    },

    components: {
        'document-set-header': __WEBPACK_IMPORTED_MODULE_0__components_DocumentSetHeader___default.a
    },

    methods: {

        requestDocumentSet: function requestDocumentSet(setId, setType) {
            __WEBPACK_IMPORTED_MODULE_1__services_document_sets_service__["a" /* default */].getSet(setId, setType).then(use.bind(this));

            function use(set) {
                this.store.data.currentDocumentSet = set;
                return set;
            }
        },

        requestDocumentSetInvitations: function requestDocumentSetInvitations(setId) {
            return __WEBPACK_IMPORTED_MODULE_3__services_user_invitations_service__["a" /* default */].getInvitationsForDocumentSet(setId).then(use.bind(this));

            function use(invitations) {
                this.invitations = invitations;
                return invitations;
            }
        },

        revoke: function revoke(invitation) {
            if (!confirm('Revoke ' + invitation.user.firstName + ' ' + invitation.user.lastName + '\'s access to ' + this.store.data.currentDocumentSet.name + '?')) return;
            var component = this;
            return __WEBPACK_IMPORTED_MODULE_3__services_user_invitations_service__["a" /* default */].revokeAccessForDocumentSet(this.setId, invitation).then(reload.bind(component));

            function reload(result) {
                return this.requestDocumentSetInvitations(this.setId);
            }
        },

        invite: function invite() {
            var component = this;
            __WEBPACK_IMPORTED_MODULE_3__services_user_invitations_service__["a" /* default */].postInvitationsForDocumentSet(this.setId, this.recipients).then(reload.bind(component)).then(clearForm.bind(this));

            function reload(result) {
                return this.requestDocumentSetInvitations(this.setId);
            }

            function clearForm(result) {
                this.resetForm();
                return result;
            }
        },

        addRecipient: function addRecipient() {
            this.recipients.push({
                userFirstName: '',
                userLastName: '',
                userEmail: ''
            });
        },

        removeRecipient: function removeRecipient(val) {
            this.recipients = this.recipients.filter(function (el) {
                return el !== val;
            });
        },

        resetForm: function resetForm() {
            this.recipients = [];
        }
    }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DocumentSetHeader__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DocumentSetHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DocumentSetHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_document_sets_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_document_sharing_service__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_js__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'documentsShare',

    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_5__store_js__["a" /* Store */],
            recipients: [],
            invitationURL: '',
            deferred: [],
            errorMessage: false,
            shareStatus: 'init'
        };
    },


    created: function created() {
        if (!this.store.data.currentDocumentSet.documents) {
            this.$router.push('/documents-view/' + this.setType + '/' + this.setId);
        }
        this.$data.recipients = [{
            email: ''
        }];
    },

    computed: {
        toShare: function toShare() {
            if (!this.store.data.currentDocumentSet.documents) return [];
            return this.store.data.currentDocumentSet.documents.filter(function (document) {
                return document.selected === true;
            });
        },
        setId: function setId() {
            return this.$route.params.setId;
        },
        setType: function setType() {
            return this.$route.params.setType;
        }
    },

    components: {
        'document-set-header': __WEBPACK_IMPORTED_MODULE_1__components_DocumentSetHeader___default.a
    },

    methods: {

        removeItem: function removeItem(id) {
            for (var i = this.$data.store.data.currentDocumentSet.documents.length - 1; i >= 0; i--) {
                if (this.$data.store.data.currentDocumentSet.documents[i].id === id) {
                    this.$data.store.data.currentDocumentSet.documents[i].selected = false;
                };
            };
        },

        addRecipient: function addRecipient() {
            this.recipients.push({
                email: ''
            });
        },

        removeRecipient: function removeRecipient(val) {
            this.recipients = this.recipients.filter(function (el) {
                return el !== val;
            });
        },

        processInvitation: function processInvitation() {
            return __WEBPACK_IMPORTED_MODULE_3__services_document_sharing_service__["a" /* default */].postLimitedInvitation(this.setId, this.toShare, this.recipients).then(use.bind(this));

            function use(result) {
                this.shareStatus = 'success';
                return result;
            }
        }
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DocumentItem__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DocumentItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DocumentItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DocumentSetHeader__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DocumentSetHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DocumentSetHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_document_sets_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_js__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'documentsView',

    props: [],

    data: function data() {
        return {
            sortedDocuments: {},
            store: __WEBPACK_IMPORTED_MODULE_4__store_js__["a" /* Store */]
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        selected: function selected() {
            var selectedCount = 0;
            if (!this.store.data.currentDocumentSet.documents) {
                return 0;
            }
            for (var i = 0; i < this.store.data.currentDocumentSet.documents.length; i++) {
                if (this.store.data.currentDocumentSet.documents[i].selected) {
                    selectedCount++;
                }
            };
            return selectedCount;
        },
        setType: function setType() {
            return this.$route.params.setType;
        },
        sharingEnabled: function sharingEnabled() {
            return this.setType == 'owneddocumentsets';
        },
        setId: function setId() {
            return this.$route.params.setId;
        }
    }, 'setType', function setType() {
        return this.$route.params.setType;
    }),

    components: {
        'document-item': __WEBPACK_IMPORTED_MODULE_1__components_DocumentItem___default.a,
        'document-set-header': __WEBPACK_IMPORTED_MODULE_2__components_DocumentSetHeader___default.a
    },

    created: function created() {
        this.requestDocumentSet(this.setId, this.setType);
    },

    methods: {

        requestDocumentSet: function requestDocumentSet(setId, setType) {
            __WEBPACK_IMPORTED_MODULE_3__services_document_sets_service__["a" /* default */].getSet(setId, setType).then(use.bind(this));

            function use(set) {
                this.store.data.currentDocumentSet = set;
                this.sortedDocuments = __WEBPACK_IMPORTED_MODULE_3__services_document_sets_service__["a" /* default */].categorizeSet(set);
                return set;
            }
        }
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* Store */],
            username: '',
            password: '',
            loginHelpStep: ''
        };
    },


    methods: {

        hashCredentials: function hashCredentials() {
            return 'Basic ' + btoa(this.username + ':' + this.password);
        },

        requestLogin: function requestLogin() {
            __WEBPACK_IMPORTED_MODULE_1__services_user_service__["a" /* default */].authenticate(this.username, this.password).then(use.bind(this)).catch(failure.bind(this));

            function use(userData) {
                if (this.$route.query.redirect) {
                    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push(this.$route.query.redirect);
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
                }
            }

            function failure(xhr) {
                this.password = '';
            }
        },

        requestPasswordReset: function requestPasswordReset() {
            __WEBPACK_IMPORTED_MODULE_1__services_user_service__["a" /* default */].forgotPassword(this.username).then(use.bind(this));

            function use(data) {
                this.setLoginHelpStep('email-sent');
            }
        },

        setLoginHelpStep: function setLoginHelpStep(step) {
            __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].resetErrors();
            this.loginHelpStep = step;
        }
    }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'logout'

});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'navbar',

    props: ['authenticated']

});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'navbar-alt',

    props: ['authenticated']

});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user_service__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'passwordReset',

    data: function data() {
        return {
            newPassword: '',
            confirmPassword: '',
            resetComplete: false
        };
    },


    created: function created() {
        __WEBPACK_IMPORTED_MODULE_1__services_user_service__["a" /* default */].logout();
    },

    computed: {
        passwordsMatch: function passwordsMatch() {
            return this.newPassword != '' && this.newPassword == this.confirmPassword;
        },
        token: function token() {
            return this.$route.query.token;
        },
        username: function username() {
            return this.$route.query.username;
        },
        newaccount: function newaccount() {
            return typeof this.$route.query.newaccount != 'undefined';
        }
    },

    methods: {
        setPassword: function setPassword() {
            console.log('newaccount', this.newaccount);

            __WEBPACK_IMPORTED_MODULE_1__services_user_service__["a" /* default */].resetPassword(this.username, this.newPassword, this.token, this.newaccount).then(use.bind(this));

            function use(data) {
                this.resetComplete = true;
            }
        }
    }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_js__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'primaryAttorneyDisplay',

    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* Store */]
        };
    },


    computed: {
        primaryAttorney: function primaryAttorney() {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.store.data.currentDocumentSet).length) {
                var pa = this.store.data.currentDocumentSet.userLinks.filter(function (u) {
                    return u.relationType === 'primary_attorney';
                });
                if (!!pa.length) {
                    return pa.pop();
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'privacy'

});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'terms'

});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user_service__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'UserSettings',

    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* Store */],
            user: {},
            edit: {
                name: false,
                email: false,
                password: false
            }
        };
    },


    created: function created() {
        this.getUser();
    },

    methods: {

        toggleEdit: function toggleEdit(prop) {
            this.edit[prop] = !this.edit[prop];
        },

        getUser: function getUser() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__services_user_service__["a" /* default */].get().then(function (user) {
                return _this.user = $.extend(true, {}, user);
            });
        },

        saveUserData: function saveUserData() {
            __WEBPACK_IMPORTED_MODULE_1__services_user_service__["a" /* default */].updateUser(this.user).then(this.disableEditMode);
        },

        disableEditMode: function disableEditMode() {
            this.edit.name = false;
            this.edit.email = false;
            this.edit.password = false;
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user_service__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'verify',

    data: function data() {
        return {
            store: __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* Store */],
            token: false,
            verificationRequestSent: false,
            verificationRequestFailed: false,
            tokenVerificationComplete: false,
            tokenVerificationFailed: false
        };
    },


    created: function created() {
        this.token = this.$route.query.token;
        if (this.token) this.verifyToken(this.token);
    },

    methods: {

        requestVerificationEmail: function requestVerificationEmail() {
            this.resetErrors();
            __WEBPACK_IMPORTED_MODULE_2__services_user_service__["a" /* default */].requestVerificationEmail().then(use.bind(this)).catch(failure.bind(this));

            function use(data) {
                this.token = false;
                this.verificationRequestSent = true;
            }

            function failure(xhr) {
                this.token = false;
                this.verificationRequestFailed = true;
            }
        },

        resetErrors: function resetErrors() {
            this.verificationRequestSent = false;
            this.verificationRequestFailed = false;
            this.tokenVerificationComplete = false;
            this.tokenVerificationFailed = false;
        },

        verifyToken: function verifyToken(token) {
            __WEBPACK_IMPORTED_MODULE_2__services_user_service__["a" /* default */].verifyToken(token).then(use.bind(this)).catch(failure.bind(this));

            function use(data) {
                this.tokenVerificationComplete = true;
                this.store.data.user = {};
            }
            function failure(xhr) {
                this.tokenVerificationFailed = true;
            }
        },

        goHome: function goHome() {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
        }
    }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_sass_assets_javascripts_bootstrap_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_sass_assets_javascripts_bootstrap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_sass_assets_javascripts_bootstrap_js__);







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('PrimaryAttorneyDisplay', __webpack_require__(32));


new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_0__App___default.a
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('formatDate', function (val) {
    if (val) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(val)).format('MM/DD/YYYY');
    }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_q__);






var DocumentSharingService = function () {
    function DocumentSharingService() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DocumentSharingService);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DocumentSharingService, [{
        key: 'postLimitedInvitation',
        value: function postLimitedInvitation(setId, documents, recipients) {

            var invitationURL = '';

            return queueInvitation().then(attachDocuments).then(attachRecipients).then(sendAnnouncement);

            function queueInvitation() {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + '/api/v1/documentsets/' + setId + '/limitedinvitations',
                    'method': 'POST',
                    'data': '{"limitedinvitation":{"hidden":false}}',
                    'dataType': 'text',
                    'processData': false,
                    'contentType': 'application/json',
                    statusCode: {
                        201: function _(data, status, xhr) {
                            invitationURL = xhr.getResponseHeader('Location');
                        }
                    }
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
            }

            function attachDocuments(response) {
                var dfd = [];
                for (var i = documents.length - 1; i >= 0; i--) {
                    dfd.push(queueDocument(documents[i].id));
                }
                return __WEBPACK_IMPORTED_MODULE_4_q___default.a.all(dfd);
            }

            function attachRecipients(response) {
                var dfd = [];
                for (var i = 0; i < recipients.length; i++) {
                    dfd.push(queueRecipient(recipients[i].email));
                }
                return __WEBPACK_IMPORTED_MODULE_4_q___default.a.all(dfd);
            }

            function sendAnnouncement() {
                return queueAnnouncement();
            }

            function queueDocument(documentId) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + invitationURL + '/documentlinks',
                    'method': 'POST',
                    'data': '{"limited_invitation_document_link":{"documentId":' + documentId + '}}',
                    'processData': false,
                    'dataType': 'text',
                    'contentType': 'application/json'
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
            }

            function queueRecipient(email) {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + invitationURL + '/emails',
                    'method': 'POST',
                    'data': '{"limited_invitation_email":{"emailAddress":"' + email + '"}}',
                    'processData': false,
                    'dataType': 'text',
                    'contentType': 'application/json'
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
            }

            function queueAnnouncement() {
                var settings = __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].defaultSettingsPlus({
                    'url': __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].baseURL + invitationURL + '/announcements',
                    'method': 'POST',
                    'data': '{"limited_invitation_announcement":{}}',
                    'processData': false,
                    'dataType': 'text',
                    'contentType': 'application/json'
                });
                return __WEBPACK_IMPORTED_MODULE_2__services_api_service__["a" /* default */].waitFor(__WEBPACK_IMPORTED_MODULE_4_q___default()($.ajax(settings)));
            }
        }
    }]);

    return DocumentSharingService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new DocumentSharingService());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 46,
	"./af.js": 46,
	"./ar": 53,
	"./ar-dz": 47,
	"./ar-dz.js": 47,
	"./ar-kw": 48,
	"./ar-kw.js": 48,
	"./ar-ly": 49,
	"./ar-ly.js": 49,
	"./ar-ma": 50,
	"./ar-ma.js": 50,
	"./ar-sa": 51,
	"./ar-sa.js": 51,
	"./ar-tn": 52,
	"./ar-tn.js": 52,
	"./ar.js": 53,
	"./az": 54,
	"./az.js": 54,
	"./be": 55,
	"./be.js": 55,
	"./bg": 56,
	"./bg.js": 56,
	"./bm": 57,
	"./bm.js": 57,
	"./bn": 59,
	"./bn-bd": 58,
	"./bn-bd.js": 58,
	"./bn.js": 59,
	"./bo": 60,
	"./bo.js": 60,
	"./br": 61,
	"./br.js": 61,
	"./bs": 62,
	"./bs.js": 62,
	"./ca": 63,
	"./ca.js": 63,
	"./cs": 64,
	"./cs.js": 64,
	"./cv": 65,
	"./cv.js": 65,
	"./cy": 66,
	"./cy.js": 66,
	"./da": 67,
	"./da.js": 67,
	"./de": 70,
	"./de-at": 68,
	"./de-at.js": 68,
	"./de-ch": 69,
	"./de-ch.js": 69,
	"./de.js": 70,
	"./dv": 71,
	"./dv.js": 71,
	"./el": 72,
	"./el.js": 72,
	"./en-au": 73,
	"./en-au.js": 73,
	"./en-ca": 74,
	"./en-ca.js": 74,
	"./en-gb": 75,
	"./en-gb.js": 75,
	"./en-ie": 76,
	"./en-ie.js": 76,
	"./en-il": 77,
	"./en-il.js": 77,
	"./en-in": 78,
	"./en-in.js": 78,
	"./en-nz": 79,
	"./en-nz.js": 79,
	"./en-sg": 80,
	"./en-sg.js": 80,
	"./eo": 81,
	"./eo.js": 81,
	"./es": 85,
	"./es-do": 82,
	"./es-do.js": 82,
	"./es-mx": 83,
	"./es-mx.js": 83,
	"./es-us": 84,
	"./es-us.js": 84,
	"./es.js": 85,
	"./et": 86,
	"./et.js": 86,
	"./eu": 87,
	"./eu.js": 87,
	"./fa": 88,
	"./fa.js": 88,
	"./fi": 89,
	"./fi.js": 89,
	"./fil": 90,
	"./fil.js": 90,
	"./fo": 91,
	"./fo.js": 91,
	"./fr": 94,
	"./fr-ca": 92,
	"./fr-ca.js": 92,
	"./fr-ch": 93,
	"./fr-ch.js": 93,
	"./fr.js": 94,
	"./fy": 95,
	"./fy.js": 95,
	"./ga": 96,
	"./ga.js": 96,
	"./gd": 97,
	"./gd.js": 97,
	"./gl": 98,
	"./gl.js": 98,
	"./gom-deva": 99,
	"./gom-deva.js": 99,
	"./gom-latn": 100,
	"./gom-latn.js": 100,
	"./gu": 101,
	"./gu.js": 101,
	"./he": 102,
	"./he.js": 102,
	"./hi": 103,
	"./hi.js": 103,
	"./hr": 104,
	"./hr.js": 104,
	"./hu": 105,
	"./hu.js": 105,
	"./hy-am": 106,
	"./hy-am.js": 106,
	"./id": 107,
	"./id.js": 107,
	"./is": 108,
	"./is.js": 108,
	"./it": 110,
	"./it-ch": 109,
	"./it-ch.js": 109,
	"./it.js": 110,
	"./ja": 111,
	"./ja.js": 111,
	"./jv": 112,
	"./jv.js": 112,
	"./ka": 113,
	"./ka.js": 113,
	"./kk": 114,
	"./kk.js": 114,
	"./km": 115,
	"./km.js": 115,
	"./kn": 116,
	"./kn.js": 116,
	"./ko": 117,
	"./ko.js": 117,
	"./ku": 118,
	"./ku.js": 118,
	"./ky": 119,
	"./ky.js": 119,
	"./lb": 120,
	"./lb.js": 120,
	"./lo": 121,
	"./lo.js": 121,
	"./lt": 122,
	"./lt.js": 122,
	"./lv": 123,
	"./lv.js": 123,
	"./me": 124,
	"./me.js": 124,
	"./mi": 125,
	"./mi.js": 125,
	"./mk": 126,
	"./mk.js": 126,
	"./ml": 127,
	"./ml.js": 127,
	"./mn": 128,
	"./mn.js": 128,
	"./mr": 129,
	"./mr.js": 129,
	"./ms": 131,
	"./ms-my": 130,
	"./ms-my.js": 130,
	"./ms.js": 131,
	"./mt": 132,
	"./mt.js": 132,
	"./my": 133,
	"./my.js": 133,
	"./nb": 134,
	"./nb.js": 134,
	"./ne": 135,
	"./ne.js": 135,
	"./nl": 137,
	"./nl-be": 136,
	"./nl-be.js": 136,
	"./nl.js": 137,
	"./nn": 138,
	"./nn.js": 138,
	"./oc-lnc": 139,
	"./oc-lnc.js": 139,
	"./pa-in": 140,
	"./pa-in.js": 140,
	"./pl": 141,
	"./pl.js": 141,
	"./pt": 143,
	"./pt-br": 142,
	"./pt-br.js": 142,
	"./pt.js": 143,
	"./ro": 144,
	"./ro.js": 144,
	"./ru": 145,
	"./ru.js": 145,
	"./sd": 146,
	"./sd.js": 146,
	"./se": 147,
	"./se.js": 147,
	"./si": 148,
	"./si.js": 148,
	"./sk": 149,
	"./sk.js": 149,
	"./sl": 150,
	"./sl.js": 150,
	"./sq": 151,
	"./sq.js": 151,
	"./sr": 153,
	"./sr-cyrl": 152,
	"./sr-cyrl.js": 152,
	"./sr.js": 153,
	"./ss": 154,
	"./ss.js": 154,
	"./sv": 155,
	"./sv.js": 155,
	"./sw": 156,
	"./sw.js": 156,
	"./ta": 157,
	"./ta.js": 157,
	"./te": 158,
	"./te.js": 158,
	"./tet": 159,
	"./tet.js": 159,
	"./tg": 160,
	"./tg.js": 160,
	"./th": 161,
	"./th.js": 161,
	"./tk": 162,
	"./tk.js": 162,
	"./tl-ph": 163,
	"./tl-ph.js": 163,
	"./tlh": 164,
	"./tlh.js": 164,
	"./tr": 165,
	"./tr.js": 165,
	"./tzl": 166,
	"./tzl.js": 166,
	"./tzm": 168,
	"./tzm-latn": 167,
	"./tzm-latn.js": 167,
	"./tzm.js": 168,
	"./ug-cn": 169,
	"./ug-cn.js": 169,
	"./uk": 170,
	"./uk.js": 170,
	"./ur": 171,
	"./ur.js": 171,
	"./uz": 173,
	"./uz-latn": 172,
	"./uz-latn.js": 172,
	"./uz.js": 173,
	"./vi": 174,
	"./vi.js": 174,
	"./x-pseudo": 175,
	"./x-pseudo.js": 175,
	"./yo": 176,
	"./yo.js": 176,
	"./zh-cn": 177,
	"./zh-cn.js": 177,
	"./zh-hk": 178,
	"./zh-hk.js": 178,
	"./zh-mo": 179,
	"./zh-mo.js": 179,
	"./zh-tw": 180,
	"./zh-tw.js": 180
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;

/***/ }),
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  "data-v-79cbd5ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  "data-v-60a3fbc7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  "data-v-6fdf8205",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(242)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  "data-v-28e2f41b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(240)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  "data-v-22bdaf80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  "data-v-b6eecf58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(241)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  "data-v-23e7fb40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(250)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  "data-v-917e6e6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  "data-v-37e637d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(239)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-1407941f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(237)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  "data-v-043e165e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-f3604e9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "terms"
    }
  }, [_c('h1', [_vm._v("Terms & Conditions")]), _vm._v(" "), _c('p', [_vm._v("Welcome to Lewis Rice’s custom-designed and secure web portal. You may choose to have complimentary access to your estate planning documents by agreeing to these terms and conditions. The secure web portal may be accessed on your desktop or mobile device and allows you to view, download, print, and email your estate planning documents. The secure web portal is encrypted and your access will be password protected through a password that you establish.")]), _vm._v(" "), _c('p', [_vm._v("The secure web portal also allows you to invite one or more others to have access to your estate planning documents. For example, you might allow access to a trusted family member who is or will be involved with your estate plan, your financial advisor, your accountant, etc. If you choose to invite others to access your estate planning documents, you can revoke their access by following the instructions on the portal. As you would expect, by allowing another individual to have access to your estate planning documents, the confidential information contained in your documents would be available to that individual. Accordingly, only trusted individuals who need access to your estate planning documents should be invited to have access to your documents on the secure web portal. Further, we recommend that you discuss with the invited individual your expectations regarding the privacy of the information contained in your estate planning documents. Allowing access to others may waive any information in your estate planning documents that might otherwise be protected by the attorney-client privilege. In many cases, that may not be a concern.")]), _vm._v(" "), _c('p', [_vm._v("Instead of allowing full access to your estate planning documents, you could instead access the portal and select specific documents to be emailed to a particular email address. For example, suppose that you were to purchase a vacation residence in the name of your revocable trust and, shortly before the closing, the title company requires you to provide a signed copy of your revocable trust. In that instance, you could access the portal from your mobile device or desktop and email your revocable trust to the title company employee. This will be a preferred option in many cases.")]), _vm._v(" "), _c('p', [_vm._v("We reserve the right to revoke the access of any party (including you) to our complimentary secure web portal at any time and for any reason, and we may do so without notice. We do not have any duty to allow you or others to access the secure web portal or to populate it with any particular documents or information. The secure web portal is provided by us on a voluntary and complimentary basis and we may discontinue the secure web portal at any time and for any reason. The provision of access to your estate planning instruments on the secure web portal does not establish a continuing attorney-client relationship between us. For example, suppose that your estate planning matters previously have been concluded and that we invite you to have access to your documents on the secure web portal. Your access to the secure web portal after our representation of you has concluded does not create a continuing attorney-client relationship.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("By using the secure web portal, you acknowledge that you have read, understand, agree and consent to all of the foregoing.")])])
}]}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.primaryAttorney != false) ? _c('div', {
    staticClass: "panel panel-primary",
    attrs: {
      "id": "primary-attorney-display"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Primary Attorney")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "fullname"
  }, [_vm._v(_vm._s(_vm.primaryAttorney.user.firstName) + _vm._s(_vm.primaryAttorney.user.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "contact-block"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('a', {
    staticClass: "email-link",
    attrs: {
      "href": 'mailto:' + _vm.primaryAttorney.user.email
    }
  }, [_vm._v(_vm._s(_vm.primaryAttorney.user.email))])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "privacy"
    }
  }, [_c('h1', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('p', [_vm._v("Lewis Rice LLC (the “"), _c('strong', [_c('em', [_vm._v("Firm")])]), _vm._v("” or “"), _c('strong', [_c('em', [_vm._v("we")])]), _vm._v("” or “"), _c('strong', [_c('em', [_vm._v("our")])]), _vm._v("”) respects your privacy and is committed to protecting the privacy of your personal data. The purpose of this policy is to provide you with information about what personal data we collect, why we collect it, how we use and handle it, how an individual could exercise his/her rights with regard to such personal data collected.")]), _vm._v(" "), _c('p', [_vm._v("This policy also describes a point of contact within the Firm where requests regarding an individual’s personal data and/or complaints about the Firm’s handling of personal data can be directed and requests for information about how the Firm is held accountable for safeguarding any personal data, should it be stored or transferred by the Firm, will be handled.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("I. PRIVACY SHIELD PRINCIPLES. ")])]), _vm._v(" "), _c('p', [_vm._v("The Firm complies with the E.U. – U.S. Privacy Shield Principles and the Swiss-U.S. Privacy Shield Principles, including the Supplemental Principles (collectively, the “"), _c('strong', [_c('em', [_vm._v("Privacy Shield Principles")])]), _vm._v("”) as set forth by the U.S. Department of Commerce regarding the collection, use and retention of personal data transferred from the European Union (“"), _c('strong', [_c('em', [_vm._v("E.U.")])]), _vm._v("”), the United Kingdom (\""), _c('em', [_c('strong', [_vm._v("U.K.")])]), _vm._v("\") and/or Switzerland to the United States (\""), _c('em', [_c('strong', [_vm._v("U.S.")])]), _vm._v("\"), respectively (the programs being described herein as the “"), _c('strong', [_c('em', [_vm._v("Privacy Shield")])]), _vm._v("”). As outlined below, the Firm adheres to and has certified to the U. S. Department of Commerce that it adheres to, the Privacy Shield Principles, including, the Privacy Shield Principles of Notice; Choice; Accountability for Onward Transfer; Security; Data Integrity and Purpose Limitation; Access; and Recourse, Enforcement, and Liability, as well as the Supplementary Principles. If there is any conflict between the terms in this Privacy Policy and the Privacy Shield Principles, the Privacy Shield Principles shall govern. To learn more about the Privacy Shield program, and to view our certification, please visit "), _c('a', {
    attrs: {
      "href": "https://www.privacyshield.gov"
    }
  }, [_vm._v("https://www.privacyshield.gov")]), _vm._v(". A list of companies that are currently certified under the Privacy Shield is available at "), _c('a', {
    attrs: {
      "href": "https://www.privacyshield.gov/list"
    }
  }, [_vm._v("https://www.privacyshield.gov/list")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Although the Firm is certified to the E.U. – U.S. Privacy Shield Principles, we do not rely on the E.U. – U.S. Privacy Shield Principles as a legal basis for transfers of personal data submitted relating to individuals in the E.U. or U.K. in light of the judgment of the Court of Justice of the E.U. in Case C-311/18. All transfers of personal data relating to individuals in the E.U. or U.K. shall be governed by data processing agreements incorporating the standard contractual clauses for the transfer of personal data to processors (2010/87/EU) and/or the standard contractual clauses for the transfer of personal data to controllers (2001/497/EC or 2004/915/EC), as applicable (collectively, the “"), _c('strong', [_c('em', [_vm._v("E.U. Standard Contractual Clauses")])]), _vm._v("”). We may, but shall not be required to, also process personal data submitted relating to individuals in Switzerland via adequate compliance mechanisms other than the Swiss-U.S. Privacy Shield Principles.")]), _vm._v(" "), _c('p', [_vm._v("Our Privacy Shield compliance is subject to the investigatory and enforcement powers of the U.S. Federal Trade Commission (“"), _c('strong', [_c('em', [_vm._v("FTC")])]), _vm._v("”), and we are committed to responding promptly to inquiries and requests by the United States Department of Commerce for information relating to the Privacy Shield Principles.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("II. HOW WE RECEIVE PERSONAL DATA & TYPES OF PERSONAL DATA RECEIVED")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('p', [_c('strong', [_vm._v("A. Ways in which We Receive Personal Data. ")]), _vm._v("The main avenue through which the Firm receives personal data is through our representation of our clients. In addition, we also receive personal data through the following sources:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Through our website ("), _c('a', {
    attrs: {
      "href": "https://www.lewisrice.com"
    }
  }, [_vm._v("www.lewisrice.com")]), _vm._v(") (our “"), _c('strong', [_c('em', [_vm._v("Website")])]), _vm._v("”), including, without limitation, your requests for information or subscriptions to our newsletters through the functionality of this Website;")]), _vm._v(" "), _c('li', [_vm._v("Through your application for employment with the Firm, whether written through written communication, email, our Website or our third party service provider(s);")]), _vm._v(" "), _c('li', [_vm._v("In communications with our clients or potential clients, whether through written communication, email, text, telephone, or other electronic messages between an individual or his/her employer or business and the Firm; or")]), _vm._v(" "), _c('li', [_vm._v("Our third party providers and other business partners (including, without limitation, our marketing consultants).")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("B. Types of Personal Data. ")]), _vm._v("Your personal data that may be collected or processed by the Firm includes:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("first and last names;")]), _vm._v(" "), _c('li', [_vm._v("address and past addresses;")]), _vm._v(" "), _c('li', [_vm._v("phone number;")]), _vm._v(" "), _c('li', [_vm._v("email address;")]), _vm._v(" "), _c('li', [_vm._v("date of birth and/or age;")]), _vm._v(" "), _c('li', [_vm._v("date of death;")]), _vm._v(" "), _c('li', [_vm._v("sex/gender,")]), _vm._v(" "), _c('li', [_vm._v("ethnicity and/or race;")]), _vm._v(" "), _c('li', [_vm._v("credit card information;")]), _vm._v(" "), _c('li', [_vm._v("IP address;")]), _vm._v(" "), _c('li', [_vm._v("non-academic titles, academic qualifications, and academic titles;")]), _vm._v(" "), _c('li', [_vm._v("firm/business/employer name, organizational titles, and departments;")]), _vm._v(" "), _c('li', [_vm._v("occupation;")]), _vm._v(" "), _c('li', [_vm._v("work experience, including job titles, company names, and dates of employment;")]), _vm._v(" "), _c('li', [_vm._v("education and education degree(s), including, majors, minors and dates of school attendance;")]), _vm._v(" "), _c('li', [_vm._v("veteran status;")]), _vm._v(" "), _c('li', [_vm._v("voluntary self-identification of disability;")]), _vm._v(" "), _c('li', [_vm._v("financial information, such as that which could be used to process invoices and payments; and")]), _vm._v(" "), _c('li', [_vm._v("any other information that might be used to identify you by another person.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("C. Cookies and Other Tracking Technologies. ")]), _vm._v("As you navigate through and/or interact with our Website, we may use automatic data collection technologies to collect certain information about your equipment, browsing actions and patterns, including:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Details of your visits to our Website, including traffic data, location data, logs, and other communication data and the resources that you access and use on the Website; and/or")]), _vm._v(" "), _c('li', [_vm._v("Information about your computer and internet connection, including your IP address, operating system, and browser type.")])]), _vm._v(" "), _c('p', [_vm._v("The information we collect automatically is statistical data and does not include personal data, but we may maintain it or associate it with personal data we collect in other ways or receive from third parties. It helps us to improve our Website and to deliver a better and more personalized service, including by enabling us to:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Estimate our audience size and usage patterns;")]), _vm._v(" "), _c('li', [_vm._v("Store information about your preferences;")]), _vm._v(" "), _c('li', [_vm._v("Speed up your searches;")]), _vm._v(" "), _c('li', [_vm._v("The technologies we use for this automatic data collection may include:\n\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("Cookies (or browser cookies). A cookie is a small file placed on the hard drive of your computer. You may refuse to accept browser cookies by activating the appropriate setting on your browser. However, if you select this setting you may be unable to access certain parts of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies when you direct your browser to our Website.")]), _vm._v(" "), _c('li', [_vm._v("Flash Cookies. Certain features of our Website may use local stored objects (or Flash cookies) to collect and store information about your preferences and navigation to, from, and on our Website. Flash cookies are not managed by the same browser settings as are used for browser cookies. For information about managing your privacy and security settings for Flash cookies, see the Subsection entitled Individual Rights under the SECURITY, CHOICE AND ACCESS Section below.")]), _vm._v(" "), _c('li', [_vm._v("Web Beacons. Pages of our the Website and our e-mails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Firm, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of certain website content and verifying system and server integrity).")])])])]), _vm._v(" "), _c('p', [_vm._v("We do not collect personal data automatically, but we may tie this information to personal data about you that we collect from other sources or you provide to us.")]), _vm._v(" "), _c('p', [_vm._v("Do Not Track (“DNT”) is a privacy preference that users can set in their web browsers. Our Website does not support DNT codes, but our Website limits tracking to the internal uses described above. Except in the case of analytics cookies, remarketing and other features of Google Display Advertising described above, our website does not track your use across multiple websites, however, other websites to which we link may. We do not control these third parties’ tracking technologies or how they may be used. If you have any questions about an advertisement or other targeted content, you should contact the responsible provider directly. Also, if you wish to opt out of interest-based advertising, please visit "), _c('a', {
    attrs: {
      "href": "http://optout.aboutads.info/",
      "target": "_blank"
    }
  }, [_vm._v("http://optout.aboutads.info")]), _vm._v(" to manage your preferences. Alternatively, if you are located in the European Union, you may visit "), _c('a', {
    attrs: {
      "href": "http://www.youronlinechoices.eu/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.youronlinechoices.eu/")]), _vm._v(". Please note that you may continue to receive generic ads.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("D. Children under the Age of 16. ")]), _vm._v("Our Website is not intended for children under 16 years of age. No one under age 16 may provide any information to or on the Website. We do not knowingly collect personal data from children under 16. If you are under 16, do not use or provide any information on this Website or on or through any of its features/register on the Website, make any purchases through the Website, use any of the interactive or public comment features of this Website or provide any information about yourself to us, including your name, address, telephone number, email address, or any screen name or user name you may use. If we learn we have collected or received personal data from a child under 16 without verification of parental consent, we will delete that information. If you believe we might have any information from or about a child under 16, please contact us at "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("III. DATA INTEGRITY AND PURPOSE LIMITATION (USES OF PERSONAL DATA)")])]), _vm._v(" "), _c('p', [_vm._v("The Firm, generally, processes personal data for the purposes of (i) counseling clients and providing legal representation and/or (ii) promoting the Firm in its marketplaces. We may also use personal data to allow individuals access to files and computer systems that are provided as part of our services or in connection with our business development, marketing, and accounting activities. Personal data is also and processed through the application for employment with the Firm. We use that information in considering your application and for communicating with you about such application. Additionally, personal data may be utilized to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection purposes or to notify you of any changes to our business, our Website or any of services. Access to personal data is controlled pursuant to the Firm’s Access Control Operating Procedures and applicable law, including, without limitation, the Privacy Shield Principles and the E.U. Standard Contractual Clauses.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("IV. SECURITY, CHOICE, AND ACCESS")])]), _vm._v(" "), _c('p', [_vm._v("In the provision of legal services, the Firm is acting as a data processor of client-controlled data. We may be a data controller with regard to personal data collected through our Website but our Website is intended for North American users only. "), _c('strong', [_c('em', [_vm._v("If you are from outside North America, please do not contact us through our Website. You may contact")])]), _vm._v(" "), _c('strong', [_c('em', [_vm._v("us by telephone at 314-444-7600, or by mail at 600 Washington Avenue, Suite 2500, St. Louis, MO 63101 Attn: Data Protection and Privacy Officer.")])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('p', [_c('strong', [_vm._v("A. Individual Rights.")]), _vm._v(" In accordance with applicable law, the Firm will facilitate an individual’s right to exercise his or her legal rights with regard to his or her personal information, such as a person’s (i) the right to access; (ii) the right to rectification; (iii) the right to erasure; (iv) the right to restrict processing; (v) the right to object to processing; (vi) the right to data portability; (vii) the right to withdraw consent and (viii) the right to lodge complaints. If you seek to exercise any such rights, please send your request by email to "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")]), _vm._v(". You also have the right to lodge your complaints with the applicable legal authorities, including, without limitation, the applicable E.U. supervisory authority(ies) (if you are an E.U. citizen).")]), _vm._v(" "), _c('p', [_vm._v("We will respond to your reasonable requests in accordance with, and within the appropriate timeframe as determined by, the respective legal authority governing the use of the applicable personal data. In most cases, we will respond to requests within one month; provided, however, if the request is complex, we may extend its response time in accordance with applicable law and regulation.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("B. Security")]), _vm._v(". In addition, to protect this data and mitigate risk of a data breach and to comply with applicable law, the Firm employs reasonable and appropriate technical and organizational security procedures and processes designed to help protect against loss, misuse, and alteration of personal data collected and processed by the Firm, which include:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Physical and logical access controls that limit who can access personal data based on business/processing need;")]), _vm._v(" "), _c('li', [_vm._v("Privacy policies for personal data and for employee personal data (a copy of which may be requested by emailing "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")]), _vm._v(");")]), _vm._v(" "), _c('li', [_vm._v("Annual employee training on our privacy policies;")]), _vm._v(" "), _c('li', [_vm._v("Employees who are bound by confidentiality and attorney-client privilege obligations;")]), _vm._v(" "), _c('li', [_vm._v("Data Protection and Privacy Officer and Incident Response Team to handle all personal data incidences or issues, including, without limitation, the handling of individual requests related to his/her personal data processed by the Firm; and")]), _vm._v(" "), _c('li', [_vm._v("The Firm’s Personal Data Incident Response Process and Business Continuity Plan that contain incident response plans for escalation and resolution of data breach incidents.")])]), _vm._v(" "), _c('p', [_vm._v("However, information transmitted on the Internet and/or stored on systems attached to the Internet is not 100% secure. As a result, we do not ensure, warrant or guarantee the security or integrity of such information.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("C. California Privacy Rights.")]), _vm._v(" California residents may be provided with additional privacy rights under applicable law, including but not limited to California Civil Code Section § 1798.83 and the California Consumer Privacy Act of 2018. For more information, see our "), _c('a', {
    attrs: {
      "href": "https://www.lewisrice.com/lewis-rice-llc-privacy-notice-for-california-residents/"
    }
  }, [_vm._v("Privacy Notice for California Residents")]), _vm._v(".")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("V.  ACCOUNTABILITY FOR ONWARD TRANSFER")])]), _vm._v(" "), _c('p', [_vm._v("The performance of legal services or the other processing of your personal data may involve the transfer of certain personal data to or from third parties, including our third party service providers. If the Firm transfers personal data subject to the Privacy Shield Principles or the E.U. Standard Contractual Clauses to a third party, the recipient will have the same level of protection as required of the Firm under the Privacy Shield or the E.U. Standard Contractual Clauses, as applicable. In addition, all third party service providers engaged by the Firm are bound by contract to refrain from using any personal data for any purpose other than the provision of the given service for the Firm. The Firm is responsible and liable under the Privacy Shield Principles and the E.U. Standard Contractual Clauses for our third-party service providers processing personal data subject to the Privacy Shield Principles or E.U. Standard Contractual Clauses in a manner consistent with the Privacy Shield Principles or E.U. Standard Contractual Clauses, as applicable.")]), _vm._v(" "), _c('p', [_vm._v("In addition to disclosures described above, we may disclose or transfer personal data to third parties in connection with, or during negotiations of, any merger, acquisition, spin-off, sale of company assets, subsidiary, any financing or any similar transaction. We may also disclose personal data to third parties in order to prevent damage or harm to us, our services or any person or property, if we believe that disclosure is required by law (including to meet national security or law enforcement requirements), or in response to a lawful request by any public or governmental authority.")]), _vm._v(" "), _c('p', [_vm._v("The Firm does not sell, trade or transfer personal data to third parties. ")]), _vm._v(" "), _c('p', [_vm._v("Except as described in this Privacy Policy, we will not otherwise disclose personal data to any third parties unless you have been provided with an opportunity to opt in to such disclosure and, in the case of personal data collected from children, the appropriate verifiable consent is obtained.")]), _vm._v(" "), _c('p', [_vm._v("If an individual wishes to opt out or limit the use and disclosure of their personal data to a third party or a use that is incompatible with the purpose for personal data was originally collected or authorized, the individual may send such request to "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("When the Firm transfers personal data to countries other than the country where it was provided, we do so in compliance with applicable data protection laws, including, as applicable, the Privacy Shield Principles and E.U. Standard Contractual Clauses, as described below. We may transfer personal data from persons outside of the U.S. to third parties located either in the U.S. or otherwise; provided that transfers to the U.S. from the E.U. will comply with the E.U. Standard Contractual Clauses and transfers to the U.S. from Switzerland will comply with the Privacy Shield Principles.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("VI. RECOURSE, ENFORCEMENT, AND LIABILITY")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('p', [_c('strong', [_vm._v("A. Point of Contact for Complaints or Questions. ")]), _vm._v("Individuals have the ability to contact the Firm regarding any questions or concerns related to its collection or handling of their personal data.")]), _vm._v(" "), _c('p', [_vm._v("Data Protection and Privacy Officer")]), _vm._v(" "), _c('p', [_vm._v("By email at "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")])]), _vm._v(" "), _c('p', [_vm._v("By mail at 600 Washington Avenue, Suite 2500, St. Louis, MO 63101 Attn: Data Protection and Privacy Officer.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("B. Verification Procedures")]), _c('strong', [_vm._v(".")]), _vm._v(" On at least an annual basis, the Firm verifies its compliance with the Privacy Shield Principles through a self-assessment conducted in accordance with its Privacy Shield Self-Assessment Policy. If you would like further information about the Firm’s verification procedures, please contact the Firm’s Data Protection and Privacy Officer at "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")]), _vm._v(". The Firm recognizes that it must respond promptly to Department of Commerce inquiries.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("C. Consequences of Non-Compliance")]), _c('strong', [_vm._v(". ")]), _vm._v("In conjunction with its certification with the EU-U.S. Privacy Shield and the Swiss-U.S. Privacy Shield, the Firm uses Better Business Bureau (BBB) EU Privacy Shield as its Independent Recourse Mechanism (IRM), and by self-certifying with Privacy Shield, it is subject to the investigatory and enforcement authority of the Federal Trade Commission.")]), _vm._v(" "), _c('p', [_vm._v("In compliance with the Privacy Shield Principles, the Firm commits to resolve complaints about your privacy and our collection or use of your personal data. Individuals who reside in the E.U. or Switzerland with inquiries or complaints regarding this Privacy Policy should first contact the Firm’s Data Protection and Privacy Officer at "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")]), _vm._v(", who will, in accordance with the Firm’s Personal Data Request Process, the Firm’s Personal Data Incident Response Process and the Firm’s Business Continuity Plan, as applicable, escalate it to the Incident Response Team (“IRT”) and/or directly to the Firm’s Management Committee, as applicable.")]), _vm._v(" "), _c('p', [_vm._v("The IRT is chaired by the Data Protection and Privacy Officer and consists of the Firm’s Data Protection and Privacy Officer and representatives from the Firm’s Information Technology department, Human Resources team and Management Committee. Suspected and confirmed personal data security incidents will be investigated by the IRT. Such investigation will include, but will not be limited to, determining the source of the breach, identifying the types of data affected, determining whether notifications must be made and instituting any remedial measures that may be necessary to avoid similar incidents in the future.")]), _vm._v(" "), _c('p', [_vm._v("The Firm has further committed to refer unresolved privacy complaints under the Privacy Shield Principles to an independent dispute resolution mechanism, the BBB EU PRIVACY SHIELD, operated by the Council of Better Business Bureaus. If you do not receive timely acknowledgment of your complaint, or if your complaint is not satisfactorily addressed, please visit "), _c('a', {
    attrs: {
      "href": "https://www.bbb.org/EU-privacy-shield/for-eu-consumers"
    }
  }, [_vm._v("www.bbb.org/EU-privacy-shield/for-eu-consumers")]), _vm._v(" for more information and to file a complaint. This service is provided free of charge to you.")]), _vm._v(" "), _c('p', [_vm._v("Under certain limited circumstances, E.U. or Swiss individuals may invoke binding Privacy Shield arbitration as a last resort if all other forms of dispute resolution have been unsuccessful. To learn more about this method of resolution and its availability to you, please visit "), _c('a', {
    attrs: {
      "href": "https://www.privacyshield.gov/article?id=How-to-Submit-a-Complaint"
    }
  }, [_vm._v("https://www.privacyshield.gov/article?id=How-to-Submit-a-Complaint")]), _vm._v(".")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("VII. CHANGES")])]), _vm._v(" "), _c('p', [_vm._v("We may amend this Privacy Policy at any time. If we make any material changes in the way we collect, use, and/or share your personal data or to this Privacy Policy, we will notify you by prominently posting notice of the changes on the websites covered by this Privacy Policy. We encourage you to periodically review this page for the latest information on our Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("VIII. CONTACT US")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('p', [_vm._v("By email at "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")])]), _vm._v(" "), _c('p', [_vm._v("By mail at 600 Washington Avenue, Suite 2500, St. Louis, MO 63101 Attn: Data Protection and Privacy Officer.")])]), _vm._v(" "), _c('p', [_vm._v("If you are a resident of a country participating in the Privacy Shield and you believe we maintain your personal data within the scope of this Privacy Shield certification, you may direct any questions or complaints to the Firm’s Data Protection and Privacy Officer, whose contact information is below:")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('p', [_vm._v("Data Protection and Privacy Officer")]), _vm._v(" "), _c('p', [_vm._v("By email at "), _c('a', {
    attrs: {
      "href": "mailto:privacyofficer@lewisrice.com"
    }
  }, [_vm._v("privacyofficer@lewisrice.com")])]), _vm._v(" "), _c('p', [_vm._v("By mail at 600 Washington Avenue, Suite 2500, St. Louis, MO 63101 Attn: Data Protection and Privacy Officer.")])]), _vm._v(" "), _c('p', [_vm._v("We are committed and required to respond to any of your inquiries on this issue within one month of receiving the inquiry.")]), _vm._v(" "), _c('p', [_vm._v("This Policy was last updated on"), _c('em', [_vm._v(" October 8, 2020.")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.lewisrice.com/content/uploads/2020/07/EU_and_Swiss_Employee_Data_Privacy_Policy_Last_Updated_7-27-20.pdf"
    }
  }, [_vm._v("E.U. and Swiss Employee Data Privacy Policy")])])])
}]}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "document-share"
    }
  }, [_c('document-set-header', {
    attrs: {
      "document-set": _vm.store.data.currentDocumentSet
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareStatus == 'init'),
      expression: "shareStatus == 'init'"
    }],
    staticClass: "row",
    attrs: {
      "id": "document-share-form"
    }
  }, [_c('div', {
    staticClass: "document-list col-xs-12"
  }, [_c('h3', [_vm._v("Sending " + _vm._s(_vm.toShare.length) + " document"), (_vm.toShare.length != 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(":")]), _vm._v(" "), _vm._l((_vm.toShare), function(document) {
    return _c('div', {
      staticClass: "document well well-sm clearfix"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(document.title))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs action",
      on: {
        "click": function($event) {
          return _vm.removeItem(document.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "recipients-block col-xs-12"
  }, [_c('h3', [_vm._v("To:")]), _vm._v(" "), _vm._l((_vm.recipients), function(recipient) {
    return _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "recipient col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (recipient.email),
        expression: "recipient.email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "email",
        "placeholder": "Recipient email"
      },
      domProps: {
        "value": (recipient.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "email", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs action removeRecipient",
      on: {
        "click": function($event) {
          return _vm.removeRecipient(recipient)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
      staticClass: "alert alert-danger"
    }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary",
    on: {
      "click": _vm.addRecipient
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" Add recipient")]), _vm._v(" "), (_vm.recipients.length) ? _c('button', {
    staticClass: "btn btn-md btn-success",
    on: {
      "click": _vm.processInvitation
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Send")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": {
        name: 'DocumentsView'
      }
    }
  }, [_vm._v("Cancel")])], 1)], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareStatus == 'success'),
      expression: "shareStatus == 'success'"
    }],
    staticClass: "row",
    attrs: {
      "id": "document-share-status"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "id": "success"
    }
  }, [_c('h2', [_vm._v("Your documents have been shared.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": {
        name: 'DocumentsView'
      }
    }
  }, [_vm._v("OK!")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": __webpack_require__(15)
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Estate Planning Document Portal")]), _vm._v(" "), (_vm.loginHelpStep == '') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:username",
      value: (_vm.username),
      expression: "username",
      arg: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:password",
      value: (_vm.password),
      expression: "password",
      arg: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.requestLogin
    }
  }, [_vm._v("login")])]), _vm._v(" "), _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.setLoginHelpStep('reset-password')
      }
    }
  }, [_vm._v("Need help logging in?")])])])]) : _vm._e(), _vm._v(" "), (_vm.loginHelpStep == 'reset-password') ? _c('div', {
    staticClass: "get-login-help"
  }, [_c('h4', [_vm._v("Enter your account email below to receive instructions for resetting your login credentials.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:username",
      value: (_vm.username),
      expression: "username",
      arg: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-default",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.requestPasswordReset
    }
  }, [_vm._v("reset password")])]), _vm._v(" "), _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.setLoginHelpStep('')
      }
    }
  }, [_vm._v("Back to login")])])])]) : _vm._e(), _vm._v(" "), (_vm.loginHelpStep == 'email-sent') ? _c('div', {
    staticClass: "get-login-help"
  }, [_c('h2', [_vm._v("Please check your email.")]), _vm._v(" "), _c('h4', [_vm._v("You should receive a message containing a link to reset your password.")]), _vm._v(" "), _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.setLoginHelpStep('')
      }
    }
  }, [_vm._v("Back to login")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "document-invitations"
    }
  }, [_c('document-set-header', {
    attrs: {
      "document-set": _vm.store.data.currentDocumentSet
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Account Access")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "invitations-block col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.invitations), function(invitation) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-7"
    }, [_vm._v("\n                    " + _vm._s(invitation.user.firstName) + " " + _vm._s(invitation.user.lastName) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_vm._v("\n                    " + _vm._s(invitation.shareStatus) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 action"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          return _vm.revoke(invitation)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "recipients-block col-xs-12"
  }, [_c('h3', [_vm._v("Invite:")]), _vm._v(" "), _vm._l((_vm.recipients), function(recipient) {
    return _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "recipient col-xs-12"
    }, [_c('div', {
      staticClass: "fields"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (recipient.userFirstName),
        expression: "recipient.userFirstName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "first name"
      },
      domProps: {
        "value": (recipient.userFirstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "userFirstName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (recipient.userLastName),
        expression: "recipient.userLastName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "last name"
      },
      domProps: {
        "value": (recipient.userLastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "userLastName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (recipient.userEmail),
        expression: "recipient.userEmail"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "email",
        "placeholder": "email"
      },
      domProps: {
        "value": (recipient.userEmail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "userEmail", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs action removeRecipient",
      on: {
        "click": function($event) {
          return _vm.removeRecipient(recipient)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary",
    on: {
      "click": _vm.addRecipient
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" Add recipient")]), _vm._v(" "), (_vm.recipients.length) ? _c('button', {
    staticClass: "btn btn-md btn-success",
    on: {
      "click": _vm.invite
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Send")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": {
        name: 'DocumentsView'
      }
    }
  }, [_vm._v("Done")])], 1)], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header clearfix"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 action"
  })])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.$route.name,
    attrs: {
      "id": "app"
    }
  }, [_c('navbar', {
    attrs: {
      "authenticated": _vm.isAuthenticated
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1 col-lg-8 col-lg-offset-2"
  }, [_c('router-view'), _vm._v(" "), (_vm.apiService.errorsOccurred) ? _c('div', {
    staticClass: "notification-bar alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, _vm._l((_vm.apiService.errorList), function(error) {
    return _c('div', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), (_vm.apiService.isWaiting) ? _c('div', {
    staticClass: "load-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1 col-lg-8 col-lg-offset-2"
  }, [_c('div', [_vm._v("©" + _vm._s(_vm.year) + " Lewis Rice")]), _vm._v(" "), _c('nav', [_c('router-link', {
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" •\n               "), _c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("Privacy Policy")])], 1), _vm._v(" "), _vm._m(0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disclaimer"
  }, [_c('small', [_c('p', [_vm._v("\n                       The Lewis Rice LLC Estate Planning Portal (the “Portal”) and the materials/documents provided through the Portal may only be used by the individuals given the right to access such Portal and materials/documents by Lewis Rice LLC (the “Firm”) for the purposes for which the Firm has indicated such access and materials/documents are being provided.  The Portal and materials/documents may not be used by any other persons or for any other purposes without express consent of the Firm.\n                   ")]), _vm._v(" "), _c('p', [_vm._v("\n                       The Portal is being, and has been, provided “as is, where is” without representation or warranty.  For avoidance of doubt, the Firm makes no representation or warranty of any kind, with regard to the operation of the Portal or, that the Portal will operate without interruption or be secure, free of harmful code, or error-free. All third-party materials, whether offered as part of the Portal or separately, are provided \"as is, where is\" and any representation or warranty of or concerning any third-party materials is strictly between client and the third-party owner or licensor of such third-party materials.\n                   ")])])])
}]}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authenticated) ? _c('nav', {
    staticClass: "topnav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "tools"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/user-settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })])], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.documentSet) ? _c('div', {
    staticClass: "document-set-header well clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.documentSet.name))]), _vm._v(" "), (_vm.documentSet.owners) ? _c('div', {
    staticClass: "owners"
  }, [_c('span', {
    staticClass: "user-label"
  }, [_vm._v("For")]), _vm._v(" "), _vm._l((_vm.documentSet.owners), function(owner) {
    return _c('div', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(owner.user.firstName) + " " + _vm._s(owner.user.lastName))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.documentSet.attorneys) ? _c('div', {
    staticClass: "more-info collapse clearfix",
    attrs: {
      "id": "moreInfoBlock"
    }
  }, [_c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "attorneys well col-xs-12",
    class: _vm.documentSet.staff.length ? 'col-sm-6' : ''
  }, _vm._l((_vm.documentSet.attorneys), function(attorney) {
    return _c('div', {
      staticClass: "attorney clearfix"
    }, [_c('div', {
      staticClass: "headshot-col col-md-3 col-md-offset-0 col-xs-6 col-xs-offset-3"
    }, [_c('img', {
      staticClass: "img-circle img-responsive headshot",
      attrs: {
        "src": attorney.user.pictureFileThumbUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 col-xs-12"
    }, [_c('h2', {
      staticClass: "user-label"
    }, [_vm._v("Attorney"), (_vm.documentSet.attorneys.length != 1) ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('h4', [_vm._v(_vm._s(attorney.user.firstName) + " " + _vm._s(attorney.user.lastName))]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": 'mailto:' + attorney.user.email
      }
    }, [_vm._v(_vm._s(attorney.user.email))])]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": 'tel:' + attorney.user.contacts.phone1
      }
    }, [_vm._v(_vm._s(attorney.user.contacts.phone1))])])])])])
  }), 0), _vm._v(" "), (_vm.documentSet.staff.length) ? _c('div', {
    staticClass: "staff col-sm-6 col-lg-6 col-xs-12 well"
  }, [_c('h2', {
    staticClass: "user-label"
  }, [_vm._v("Paralegals/Assistants")]), _vm._v(" "), _c('ul', {
    staticClass: "staff-list"
  }, _vm._l((_vm.documentSet.staff), function(staff) {
    return _c('li', {
      staticClass: "info-block"
    }, [_c('h4', [_vm._v(_vm._s(staff.user.firstName) + _vm._s(staff.user.lastName))]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": 'mailto:' + staff.user.email,
        "title": ""
      }
    }, [_vm._v(_vm._s(staff.user.email))])])])
  }), 0)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.documentSet.attorneys) ? _c('a', {
    staticClass: "more-btn",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#moreInfoBlock",
      "aria-expanded": "false",
      "aria-controls": "moreInfoBlock"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down"
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-block"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": _vm.apiDomain,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(_vm._s(_vm.document.title))])]), _vm._v(" "), (_vm.sharingEnabled) ? _c('span', {
    staticClass: "toolbar"
  }, [_c('a', {
    staticClass: "action",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateSelected($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-square-o"
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-settings"
    }
  }, [_c('h1', [_vm._v("User Settings")]), _vm._v(" "), _c('section', {
    staticClass: "user-data-display"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.edit.name) ? _c('div', {
    staticClass: "col-xs-10 col-sm-9 name-input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "palceholder": "Last Name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-xs-10 col-sm-9"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        return _vm.toggleEdit('name')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), (_vm.edit.email) ? _c('div', {
    staticClass: "col-xs-10 col-sm-9 name-input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-xs-10 col-sm-9"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        return _vm.toggleEdit('email')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), (_vm.edit.password) ? _c('div', {
    staticClass: "col-xs-10 col-sm-9 name-input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-xs-10 col-sm-9"
  }, [_vm._v("••••••••••••")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        return _vm.toggleEdit('password')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "change-password col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveUserData()
      }
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Done")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-2 fullname"
  }, [_c('b', [_vm._v("Name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-2 fullname"
  }, [_c('b', [_vm._v("Email:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-2 fullname"
  }, [_c('b', [_vm._v("Password:")])])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interior-view",
    attrs: {
      "id": "documentsSets"
    }
  }, [(_vm.invitations.length) ? _c('section', {
    staticClass: "invitations"
  }, [_c('div', [_c('h3', [_vm._v("Invitations")]), _vm._v(" "), _vm._l((_vm.invitations), function(invitation) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-8 text-left invitation-title"
    }, [_vm._v(_vm._s(invitation.documentSet.fullName))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 text-right"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.handleInvitation(invitation, 'accepted')
        }
      }
    }, [_vm._v("Accept")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.handleInvitation(invitation, 'declined')
        }
      }
    }, [_vm._v("Decline")])])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.documentSetsExist) ? _c('section', {
    staticClass: "document-sets clearfix"
  }, [(_vm.store.data.documentSets.ownedSets.length) ? _c('div', [_c('h3', [_vm._v("My Documents")]), _vm._v(" "), _vm._l((_vm.store.data.documentSets.ownedSets), function(set) {
    return _c('p', [_c('router-link', {
      staticClass: "btn btn-wide btn-document-set",
      attrs: {
        "to": '/documents-view/owneddocumentsets/' + set.id
      }
    }, [_vm._v(_vm._s(set.name))])], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.store.data.documentSets.sharedSets.length) ? _c('div', [_c('h3', [_vm._v("Documents Shared With Me")]), _vm._v(" "), _vm._l((_vm.store.data.documentSets.sharedSets), function(set) {
    return _c('p', [_c('router-link', {
      staticClass: "btn btn-wide btn-document-set",
      attrs: {
        "to": '/documents-view/shareddocumentsets/' + set.id
      }
    }, [_vm._l((set.owners), function(owner) {
      return _c('div', [_vm._v(_vm._s(owner.user.firstName) + " " + _vm._s(owner.user.lastName))])
    }), _vm._v(" "), _c('div', {
      staticClass: "set-title"
    }, [_vm._v(_vm._s(set.name))])], 2)], 1)
  })], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "accept-invitation"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": __webpack_require__(15)
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Estate Planning Document Portal")]), _vm._v(" "), (_vm.checkComplete) ? _c('div', [_c('h2', [_vm._v("Welcome!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-default",
    on: {
      "click": function($event) {
        return _vm.goSetPassword()
      }
    }
  }, [_vm._v("Continue")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("It looks like this is your first time here."), _c('br'), _vm._v("Let's complete your account setup.")])
}]}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authenticated) ? _c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top navbar-inverse"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": __webpack_require__(15)
    }
  })])], 1), _vm._v(" "), (_vm.authenticated) ? _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-mobile-collapse-menu"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/logout",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v("Logout")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-settings",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v("My Settings")])], 1)])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-mobile-collapse-menu",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "password-reset"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": __webpack_require__(15)
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Estate Planning Document Portal")]), _vm._v(" "), (!_vm.resetComplete) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "readonly": "",
      "disabled": "",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "new password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    attrs: {
      "type": "password",
      "name": "confirmPassword",
      "placeholder": "confirm password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "disabled": !_vm.passwordsMatch,
      "type": "submit"
    },
    on: {
      "click": _vm.setPassword
    }
  }, [_vm._v("Set Password")])]), _vm._v(" "), _c('div', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Back to login")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.resetComplete) ? _c('div', [_c('h2', [_vm._v("Your password has been set.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary"
  }, [_vm._v("Continue")])])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    There was a problem logging out.\n")])
},staticRenderFns: []}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "documents-view"
    }
  }, [_c('document-set-header', {
    attrs: {
      "document-set": _vm.store.data.currentDocumentSet
    }
  }), _vm._v(" "), (_vm.sharingEnabled) ? _c('div', {
    staticClass: "row sharing-row"
  }, [_c('div', {
    staticClass: "col-xs-4 manage-users-controls"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'DocumentsInvitations'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Users\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 document-select-controls"
  }, [(!_vm.selected) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Share selected")]) : _vm._e(), _vm._v(" "), (_vm.selected) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'DocumentsShare'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Share " + _vm._s(_vm.selected) + " document"), (_vm.selected != 1) ? _c('span', [_vm._v("s")]) : _vm._e()]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedDocuments), function(docs, category) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 document-group data-item"
    }, [_c('h3', {
      staticClass: "document-group-title"
    }, [_vm._v(_vm._s(category))]), _vm._v(" "), _vm._l((docs), function(doc) {
      return _c('document-item', {
        key: doc.id,
        attrs: {
          "document": doc,
          "sharingEnabled": _vm.sharingEnabled
        },
        on: {
          "update:document": function($event) {
            doc = $event
          }
        }
      })
    })], 2)])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "verify"
    }
  }, [(!_vm.token) ? _c('div', [(!_vm.verificationRequestSent) ? _c('div', [_c('h1', [_vm._v("Before you proceed")]), _vm._v(" "), _c('p', [_vm._v("For your security, please confirm your email address in order to verify your account.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        return _vm.requestVerificationEmail()
      }
    }
  }, [_vm._v("Send Verification Email")])]) : _vm._e(), _vm._v(" "), (_vm.verificationRequestSent) ? _c('div', [_c('h2', [_vm._v("Please check your email")]), _vm._v(" "), _c('p', [_vm._v("Look for a message from \"Lewis Rice Estate Planning Portal\" containing a verification link. Click the link in the email to complete your account set up.")]), _vm._v(" "), _c('p', [_vm._v("If you do not receive the verification email, please check your Spam or Junk E-Mail folder, or request another verification email.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        return _vm.requestVerificationEmail()
      }
    }
  }, [_vm._v("Re-Send Verification Email")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.token) ? _c('div', [(!_vm.tokenVerificationComplete) ? _c('div', [_c('h1', [_vm._v("Verifying...")]), _vm._v(" "), (_vm.tokenVerificationFailed) ? _c('div', [_c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        return _vm.requestVerificationEmail()
      }
    }
  }, [_vm._v("Re-Send Verification Email")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tokenVerificationComplete) ? _c('div', [_c('h1', [_vm._v("Account Verified")]), _vm._v(" "), _c('p', [_vm._v("Your account is now verified and fully activated. You may now view, download, and share your estate planning documents.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_vm._v("View My Documents")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Be sure to bookmark "), _c('a', {
    attrs: {
      "href": "https://www.lrepdocs.com"
    }
  }, [_vm._v("https://www.lrepdocs.com")]), _vm._v(".")])
}]}

/***/ })
],[203]);


// WEBPACK FOOTER //
// static/js/app.5c56f07a51ec75fc6f5d.js